import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from "@material-ui/core/Grid";
import interestIcon from "Assets/Svg/interest-con.svg";
import "Module/Subscription/Recruit/index.scss";
import Button from "@material-ui/core/Button";
import linkedinIcon from "Assets/Svg/linkedin-white.svg";
import ReactPhoneInput from "react-phone-input-2";
import checkIcon from "Assets/newicons/action/check/glyph/check-plain-glyph-16-px.svg";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { DatePickerComponent } from "Component/Custom";
import { getEJ2CalenderDateFormat } from "Utils";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";

class PersonalDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      contacttypevalue: "",
      fullname: "",
      email: "",
      city: "",
      phonenumber: "",
      institutename: "",
      coursename: "",
      graduatingyear: "",
      courseTypes: [],
      courseId: "",
      employmentTypes: [],
      companyname: "",
      title: "",
      EmploymentTypeId: "",
      endDate: "",
      startDate: "",
      advancedProficiency: "",
      workingProficiency: "",
      elementaryProficiency: "",
      linkedInRef: "",
      behanceRef: "",
      githubRef: "",
      dribbbleRef: "",
      websiteRef: "",
      twitterRef: "",

      valuesArray: [
        {
          icon: interestIcon,
          title: "In it together",
          description: "Together, we can achieve anything.",
        },
        {
          icon: interestIcon,
          title: "In it together",
          description: "Together, we can achieve anything.",
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  OnPhoneChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  SelecttoDate(args) {
    const date = this.ConvertDate(args.value);
    const endDate = date;
    this.setState({ endDate });
  }

  SelectStartDate(args) {
    const date = this.ConvertDate(args.value);
    const startDate = date;
    this.setState({ startDate });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const {
      fullname,
      email,
      city,
      phonenumber,
      graduatingyear,
      institutename,
      coursename,
      courseTypes,
      courseId,
      title,
      companyname,
      location,
      employmentTypes,
      EmploymentTypeId,
    } = this.state;
    return (
      <div style={{ background: "#f9f9f9" }} className="fluid-container">
        <p
          style={{
            color: "#010709",
            fontSize: 24,
            marginBottom: 32,
            fontWeight: "bold",
          }}
        >
          Submit your application
        </p>
        <div>
          <p className="large-text-dark-seondary t-bold margin-bottom-24">
            Personal Information
          </p>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Full name *</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: fullname,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("fullname", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Email *</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: email,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("email", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Phone *</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12} className="margin-bottom-16">
              <ReactPhoneInput
                defaultCountry={"in"}
                countryCodeEditable={true}
                className="form-control margin-bottom-16"
                value={this.state.phonenumber}
                onChange={(value) => this.OnPhoneChange("phonenumber", value)}
                InputProps={{ maxLength: 15, minLength: 5 }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Current city</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: city,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("city", value);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <div>
          <p className="large-text-dark-seondary t-bold margin-bottom-24">
            Education
          </p>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">
                Most relevant *
              </p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={selectinputconverter({
                  value: courseId,
                  placeholder: "",
                  label: "Course type",
                  options: courseTypes,
                })}
                onChange={(value) => {
                  this.handleSectionChange(value, "courseId");
                }}
              />
              <DynamicForm
                fields={textinputconverter({
                  value: institutename,
                  placeholder: "",
                  label: "Institute name",
                })}
                onChange={(value) => {
                  this.handleChange("institutename", value);
                }}
              />
              <DynamicForm
                fields={textinputconverter({
                  value: coursename,
                  placeholder: "",
                  label: " Course name",
                })}
                onChange={(value) => {
                  this.handleChange("coursename", value);
                }}
              />
              <DynamicForm
                fields={textinputconverter({
                  value: graduatingyear,
                  placeholder: "",
                  label: "Graduating year",
                })}
                onChange={(value) => {
                  this.handleChange("graduatingyear", value);
                }}
              />
            </Grid>
          </Grid>
          <p
            className="normal-blue cursor-pointer t-bold"
            // onClick={this.addNewOption}
          >
            + New education
          </p>
        </div>
        <div>
          <p className="large-text-dark-seondary t-bold margin-bottom-24">
            Work experience
          </p>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">
                Most relevant *
              </p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: title,
                  placeholder: "",
                  label: "Title",
                })}
                onChange={(value) => {
                  this.handleChange("title", value);
                }}
              />
              <DynamicForm
                fields={textinputconverter({
                  value: companyname,
                  placeholder: "",
                  label: "Company name",
                })}
                onChange={(value) => {
                  this.handleChange("companyname", value);
                }}
              />
              <DynamicForm
                fields={selectinputconverter({
                  value: EmploymentTypeId,
                  placeholder: "",
                  label: "Employment type",
                  options: employmentTypes,
                })}
                onChange={(value) => {
                  this.handleChange("EmploymentTypeId", value);
                }}
              />
              <DynamicForm
                fields={textinputconverter({
                  value: location,
                  placeholder: "",
                  label: "Location",
                })}
                onChange={(value) => {
                  this.handleChange("location", value);
                }}
              />

              <div>
                <span className="floatleft">
                  <p className="input-label">Start date</p>
                  <DatePickerComponent
                    value={this.state.startdate}
                    id="startDate"
                    allowEdit
                    format={getEJ2CalenderDateFormat()}
                    // min={this.state.minApplyDate}
                    change={this.SelectStartDate.bind(this)}
                  />
                </span>
                <span className="floatleft">
                  <p className="input-label">End date</p>
                  <DatePickerComponent
                    id="endDate"
                    allowEdit
                    value={this.state.endDate}
                    format={getEJ2CalenderDateFormat()}
                    min={this.state.startDate}
                    change={this.SelecttoDate.bind(this)}
                  />
                </span>
              </div>
            </Grid>
          </Grid>
          <p
            className="normal-blue cursor-pointer t-bold"
            // onClick={this.addNewOption}
          >
            + New work experience
          </p>
        </div>
        <div>
          <p className="large-text-dark-seondary t-bold margin-bottom-24">
            Skills and languages
          </p>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">
                Advanced proficiency
              </p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textareainputconverter({
                  value: this.state.advancedProficiency,
                  label: "",
                  placeholder: "",
                })}
                onChange={(e) => this.handleChange("advancedProficiency", e)}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">
                Working proficiency
              </p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textareainputconverter({
                  value: this.state.workingProficiency,
                  label: "",
                  placeholder: "",
                })}
                onChange={(e) => this.handleChange("workingProficiency", e)}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">
                Elementary proficiency
              </p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textareainputconverter({
                  value: this.state.elementaryProficiency,
                  label: "",
                  placeholder: "",
                })}
                onChange={(e) => this.handleChange("elementaryProficiency", e)}
              />
            </Grid>
          </Grid>
        </div>
        <div>
          <p className="large-text-dark-seondary t-bold margin-bottom-24">
            Online presence
          </p>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">LinkedIn</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.linkedInRef,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("linkedInRef", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Github</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.githubRef,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("githubRef", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Behance</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.behanceRef,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("behanceRef", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Dribbble</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.dribbbleRef,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("dribbbleRef", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Twitter</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.twitterRef,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("twitterRef", value);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={3} sm={12}>
              <p className="normal-dark-secondary margin-top-8">Website</p>
            </Grid>
            <Grid item xs={12} md={4} sm={12}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.websiteRef,
                  placeholder: "",
                  label: "",
                })}
                onChange={(value) => {
                  this.handleChange("websiteRef", value);
                }}
              />
              <Button
                className="btn btn-primary-md-blue margin-top-40"
                variant="contained"
                onClick={this.props.uploadDocument}
              >
                Proceed to document upload
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(PersonalDetails));
